import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { createCampaign } from '../../services/api';
import { useNavigate } from 'react-router-dom';

const CreateCampaignModal = ({ show, onHide, selectedIds }) => {
    const [nome, setNome] = useState('');
    const [descricao, setDescricao] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleSubmit = async () => {
        if (!nome) {
            setError('Defina um nome para a campanha.');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await createCampaign({
                nome,
                descricao,
                clientes: selectedIds
            });

            if (response.success) {
                // Redireciona para detalhes da campanha
                navigate(`/dashboard/campanhas/${response.id}`);
                onHide(); // Fecha modal
            } else {
                setError(response.message || 'Erro ao criar campanha.');
            }
        } catch (err) {
            setError('Erro inesperado.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Criar Nova Campanha</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Alert variant="info">
                    Você selecionou <strong>{selectedIds.length}</strong> clientes para esta campanha.
                </Alert>

                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Nome da Campanha</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Ex: WinBack Natal 2025"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Descrição (Opcional)</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={descricao}
                            onChange={(e) => setDescricao(e.target.value)}
                        />
                    </Form.Group>
                </Form>

                {error && <Alert variant="danger">{error}</Alert>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={loading}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? 'Criando...' : 'Criar Campanha 🚀'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateCampaignModal;
